function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.953 4.721l-.614 16.594a.56.56 0 0 1-.548.526H4.173a.56.56 0 0 1-.547-.526L3.01 4.72a.83.83 0 0 0-1.658.062l.615 16.593A2.218 2.218 0 0 0 4.173 23.5h10.618a2.218 2.218 0 0 0 2.206-2.124l.614-16.593a.83.83 0 0 0-1.658-.062z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.819 8.07v11.282a.663.663 0 1 0 1.327 0V8.07a.663.663 0 1 0-1.327 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.169 8.09l.332 11.282a.663.663 0 1 0 1.326-.04L6.496 8.052a.663.663 0 1 0-1.327.039z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.469 8.05l-.332 11.283a.663.663 0 1 0 1.327.039l.332-11.282a.663.663 0 1 0-1.327-.04z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.187 5.084h16.59a.83.83 0 1 0 0-1.66H1.188a.83.83 0 1 0 0 1.66z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.962 3.985l.345-1.21c.074-.258.41-.511.68-.511h2.991c.27 0 .605.252.68.512l.345 1.209 1.595-.456-.345-1.209c-.278-.972-1.265-1.716-2.275-1.716H7.986c-1.01 0-1.997.745-2.274 1.716l-.346 1.209z"
})));

var SvgRemovePostIcon = function SvgRemovePostIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemovePostIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-post-icon.bcdfa92e.svg";
export { ForwardRef as ReactComponent };